import { Component, Prop, Vue } from 'vue-property-decorator';

export type ModalSize = 'Small' | 'Medium' | 'Large';

@Component
export default class ModalComponent extends Vue {

    @Prop() public name!: string;
    @Prop() public size!: ModalSize;

    public get labelName(): string {

        return `${name}Label`;
    }

    public get modalSizeClass(): string {

        if (this.size === 'Medium') {
            return 'modal-md';
        }

        if (this.size === 'Large') {
            return 'modal-lg';
        }

        return 'modal-sm';
    }

    public get hasFooter(): boolean {

        return !!this.$slots.footer;
    }

}
